import { Injectable } from '@angular/core';
import { EntityType, JkEntityV2,jkLib,dateFormatter, AgComboBoxEditor, } from 'jk-service';
import { AgCheckBoxEditor, AgTextAreaEditor } from 'jk-service';
import { Syssd } from '../entity/Syssd-angular';

export interface SyssdData {     COMPANY: string ;     CREATOR: string;     USR_GROUP: string ;     CREATE_DATE: string;     MODIFIER: string;     MODI_DATE: string;     FLAG: number; }


@Injectable({
  providedIn: 'root'
})
export class SyssdServicePkg extends JkEntityV2 { 


  constructor() {
    super();
    this.linkMasterFields = '' ; 
    this.defaultItem = new Syssd(); 
    this.entityType.type = EntityType.master;
    this.columnLabel = { COMPANY: '公司代號', CREATOR: '建檔者代號', USR_GROUP: '群組', CREATE_DATE: '建檔日期', MODIFIER: '修改者代號', MODI_DATE: '修改日期', FLAG: '更新次數', 
         }; 

    this.fieldNames = '' ;
    this.fieldLengths = {} ;
    this.columnDefs = [
    ];
    this.columnDefsVir = [
    ];
    this.tableName = 'SYSSD' ;
    this.isSys =false; 
    this.sqlSelect = `SELECT SYSSD.*  FROM SYSSD` ;
    this.sqlWhereDefault = `/*WHERE*/ WHERE 1=1` ;
    this.sqlOrderDefault = ` ORDER BY SD001` ;
    this.keyFields = ['SD001'];
    this.url = '/db/crud'; 
    this.rememberFields = [];
    this.requiredFields = [];
    this.seqField = '' ;
    this.seqFieldLength = 0 ;
  }
  override async validateItem(item: Syssd): Promise<boolean> {
    let bool = await super.validateItem(item);
    return bool;
  }

  override async newRecord(newItem:Syssd): Promise<Syssd> {
  await  super.newRecord(newItem);
    return newItem;
  }




}

